const version = 'v1';

//-----------------------------------------------------------------------------//
//interviews
const interviews = `${version}/interviews`;
const ddeleteInterview = `${version}/interviews`;
const interviewPublic = `public/interviews`;
const managerResponsability = `${version}/interviews/include-manager-responsible`;
const managerResponsabilityTheClass = `${version}/interviews/include-manager-responsible-the-class-room`;
const formQuestionsData = `${version}/questions/module`;
const migrateInterviews = `${version}/interviews/migrate-interview`;
const interviewsPublic = `interviews`;
const interviewById = `${version}/interviews/id`;
const interviewsModule = `${interviews}/module`;
const sendInterviewCertificate = `${interviews}/send-email-certficate`;
const findInterviewsByUserAuth = `${interviews}/by-user-auth`;
const generateCertificate = `${interviews}/certificate`;
const active = `${interviews}/active`;
const updateConditionUse = `${interviews}/update-conditions-use`;
const proferrionalSituation = `${version}/professional-situation/module`;

const undoDesist = `${version}/interviews/undo-desist-interview`;
const realizeDesist = `${version}/interviews/realize-desist-interview`;
const lastInterview = `public/interviews/candidate`;
const alertAwaitingEvaluation = `${version}/interviews/alert-interview-awainting-evaluation`;

export const ENDPOINT_LAST_INTERVIEW = lastInterview;
export const ENDPOINT_HAS_AWAITING_EVALUATION = alertAwaitingEvaluation;
export const ENDPOINT_UNDO_INTERVIEWS = undoDesist;
export const ENDPOINT_GET_INTERVIEW_JOHARI = interviewPublic;

export const ENDPOINT_SET_MANAGER_RESPONSABILITY = managerResponsability;
export const ENDPOINT_SET_MANAGER_RESPONSABILITY_THE_CLASS =
  managerResponsabilityTheClass;
export const ENDPOINT_REALIZE_INTERVIEWS = realizeDesist;

export const ENDPOINT_INTERVIEWS = interviews;
export const ENDPOINT_DELETE_INTERVIEW = ddeleteInterview;
export const ENDPOINT_FORM_QUESTIONS_DATA = formQuestionsData;
export const PROFESSIONAL_SITUATION = proferrionalSituation;
export const ENDPOINT_MIGRATE_INTERVIEWS = migrateInterviews;
export const ENDPOINT_INTERVIEWS_PUBLIC = interviewsPublic;
export const ENDPOINT_INTERVIEWS_BY_ID = interviewById;
export const ENDPOINT_INTERVIEWS_MODULE = interviewsModule;
export const ENDPOINT_SEND_INTERVIEW_CERTIFICATE = sendInterviewCertificate;
export const ENDPOINT_INTERVIEWS_BY_USER_AUTH = findInterviewsByUserAuth;
export const ENDPOINT_GENERATE_CERTIFICATE = generateCertificate;
export const ENDPOINT_ACTIVE_INTERVIEWS = active;
export const ENDPOINT_UPDATE_CONDITIONS_USE = updateConditionUse;

//-----------------------------------------------------------------------------//
//candidates
const candidates = `${version}/candidates`;
const interviewsRegistrationData = `${version}/interviews/candidates/registration-data`;
export const ENDPOINT_CANDIDATES = candidates;
export const ENDPOINT_INTERVIEWS_REGISTRATION_DATA = interviewsRegistrationData;

//-----------------------------------------------------------------------------//
//candidates
const modules = `public/modules`;

export const ENDPOINT_PUBLIC_MODULES = modules;

//-----------------------------------------------------------------------------//
//answers
const answers = `${version}/answers`;
const answerInterview = `${answers}/interview`;
const resendAnswersInterview = `${answers}/resend-answers-interview`;
const resendAnswersInterviewMutiple = `${answers}/resend-answers-interview/batch`;
const sendAnswersInterview = `${answers}/send-answers-interview/module`;
const prepareAnswersForInterview = `${answers}/prepare-answers/interview`;

export const ENDPOINT_ANSWERS = answers;
export const ENDPOINT_ANSWER_INTERVEW = answerInterview;
export const ENDPOINT_RESEND_ANSWERS_INTERVIEW = resendAnswersInterview;
export const ENDPOINT_RESEND_ANSWERS_INTERVIEW_MUTIPLE =
  resendAnswersInterviewMutiple;
export const ENDPOINT_SEND_ANSWERS_INTERVIEW = sendAnswersInterview;
export const ENDPOINT_PREPARE_ANSWERS_FOR_INTERVIEW =
  prepareAnswersForInterview;

//-----------------------------------------------------------------------------//
//user
const users = `${version}/user`;
const userMe = `${version}/user/me`;
const userSebrae = `${users}/sebrae`;
const userCheck = `${users}/check`;
const userResendEmailValidate = `${users}/resend-email-validate-user`;
const userSendEmailValidate = `${users}/send-email-validate-user`;
const managers = `${users}/find-managers-for-name-and-uf-the-managers-authenticated`;
const managersByUfId = `${users}/find-managers-for-name-and-uf`;

export const ENDPOINT_USER = users;
export const ENDPOINT_USER_ME = userMe;
export const ENDPOINT_MANAGER_SEARCH = managers;
export const ENDPOINT_FIND_MANAGER_BY_ID_UF = managersByUfId;
export const ENDPOINT_GET_SEBRAE = userSebrae;
export const ENDPOINT_USER_CHECK = userCheck;
export const ENDPOINT_RESEND_EMAIL_VALIDATE_USER = userResendEmailValidate;
export const ENDPOINT_SEND_EMAIL_VALIDATE_USER = userSendEmailValidate;

//-----------------------------------------------------------------------------//
//regional
const regional = `${version}/regional`;
const updateRegional = `${version}/regional/update`;
const validateNameRegional = `${regional}/validate-name-regional`;
const getListRegionals = `${regional}/find-all-regional-paged`;
const createRegional = `${regional}/create`;
const activeRegional = `${regional}/active`;

const allRegionals = `${regional}/find-all-regional-for-status-in-uf`;

export const ENDPOINT__VALIDATE_NAME_REGIONAL = validateNameRegional;
export const ENDPOINT_GET_ALL_REGIONALS = getListRegionals;
export const ENDPOINT_CREATE_REGIONAL = createRegional;
export const ENDPOINT_ACTIVE_REGIONAL = activeRegional;
export const ENDPOINT_ALL_REGIONALS = allRegionals;
export const ENDPOINT_UPDATE_REGIONAL = updateRegional;

//-----------------------------------------------------------------------------//
//cities - uf
const cities = `/public/cities`;
const ufs = `/public/ufs`;

export const ENDPOINT_UFS = ufs;
export const ENDPOINT_CITIES = cities;

//-----------------------------------------------------------------------------//
//chat
const chat = `${version}/chat/param`;
const firstIterationChat = `${version}/chat/iterations/interview`;
const rollback = `${version}/chat/param/rollback`;
const last = `${version}/chat/param/last`;
const chatIterations = `${version}/chat/iterations/interview`;

export const ENDPOINT_CHAT = chat;
export const ENDPOINT_CHAT_FIRST_ITERATIONS = firstIterationChat;
export const ENDPOINT_ROLLBACK = rollback;
export const ENDPOINT_LAST = last;
export const ENDPOINT_CHAT_ITERATIONS = chatIterations;

//-----------------------------------------------------------------------------//
//manage-class
const createClassRoom = `${version}/class-room`;
const linkInterview = `${version}/class-room/link-to-classs`;
const getCompletDataItem = `${version}/class-room/interview`;
const getClassRoom = `${version}/class-room/module`;
const getClassRoomId = `${version}/class-room`;
const editClassRoom = `${version}/class-room`;
const comment = `${version}/class-room/comment-classroom-interview`;
const listClassRoom = `${version}/class-room/module`;
const gestores = `${version}/user/find-managers-for-name-and-uf-the-class-room`;

export const ENDPOINT_CREATE_CLASS_ROOM = createClassRoom;
export const ENDPOINT_SET_OWNER_CLASS = gestores;
export const ENDPOINT_LIST_CLASS_ROOM = listClassRoom;
export const ENDPOINT_LINK_INTERVIEW_TO_CLASS_ROOM = linkInterview;
export const ENDPOINT_GET_CLASS_ROOM = getClassRoom;
export const ENDPOINT_GET_CLASS_ROOM_ID = getClassRoomId;
export const ENDPOINT_EDIT_CLASS_ROOM = editClassRoom;

export const ENDPOINT_GET_COMPLETE_DATA_ITEM = getCompletDataItem;
export const ENDPOINT_SAVE_COMMENT = comment;

//-----------------------------------------------------------------------------//
//calibration-control
const calibrationControl = `${version}/calibration-control`;
const statusLastCalibration = `${calibrationControl}/last`;
const historicStatusLastCalibration = `${calibrationControl}/historic`;
const calibrationHistory = `${version}/calibration-history`;
const calibrationHistoryDetail = `${calibrationHistory}/detail`;

export const ENDPOINT_CALIBRATION_CONTROL = calibrationControl;
export const ENDPOINT_LAST_STATUS_CALIBRATION = statusLastCalibration;
export const ENDPOINT_HISTORIC_LAST_STATUS_CALIBRATION =
  historicStatusLastCalibration;
export const ENDPOINT_CALIBRATION_HISTORY = calibrationHistory;
export const ENDPOINT_CALIBRATION_HISTORY_DETAIL = calibrationHistoryDetail;

//-----------------------------------------------------------------------------//
//Analysis
const analysis = `${version}/analysis/answer`;
export const ENDPOINT_ANALYSIS = analysis;

//-----------------------------------------------------------------------------//
//filters
const testFilter = `${version}/test-filter`;
const verifyFilter = `${testFilter}/filters/states`;
const validateFilterByAnser = `${testFilter}/validate-filters-new/answer`;

export const ENDPOINT_VERIFY_HAS_ANY_FILTER_ACTIVE = verifyFilter;
export const ENDPOINT_VALIDATE_FILTER_BY_ANSWER = validateFilterByAnser;

//-----------------------------------------------------------------------------//
//email-control
const emailControl = `${version}/emailcontrol`;
const sendEmailReinterview = `${emailControl}/interview`;
const sendEmailSubscription = `${emailControl}/send-email-subscription`;
const sednEmailResult = `${emailControl}/send-email-result`;

export const ENDPOINT_SEND_EMAIL_CONTROL_REINTERVIEW = sendEmailReinterview;
export const ENDPOINT_SEND_EMAIL_SUBSCRIPTION = sendEmailSubscription;
export const ENDPOINT_SEND_EMAIL_RESULT = sednEmailResult;

//-----------------------------------------------------------------------------//
//range-score
const rangeScore = `${version}/range-score`;

export const ENDPOINT_RANGE_SCORE = rangeScore;

//-----------------------------------------------------------------------------//
//questionario perfil
const quizProfile = `${version}/quiz-profile/steps`;
const quizProfileCreate = `${version}/quiz-profile/create`;
const quizProfileByStep = `${version}/quiz-profile/step/order`;
const quizProfileByAnswer = `${version}/quiz-profile/update-answer-questionneire`;
const quizAddProfileByAnswer = `${version}/quiz-profile/add-answer-questionneire`;
const quizProfileByidInterview = `${version}/quiz-profile/quiz`;
const finishQuiz = `${version}/quiz-profile/finish-quiz`;
const sendEmail = `${version}/quiz-profile/send-link-email-quiz`;
const sendEmailLote = `${version}/quiz-profile/send-link-email-quiz-lote`;

export const ENDPOINT_QUIZ_PROFILES = quizProfile;
export const ENDPOINT_CREATE_QUIZ_PROFILES = quizProfileCreate;
export const ENDPOINT_GET_QUIZ_PROFILES_BY_STEP = quizProfileByStep;
export const ENDPOINT_SAVE_QUIZ_PROFILES_BY_ANSWER = quizProfileByAnswer;
export const ENDPOINT_ADD_QUIZ_TO_PROFILE = quizAddProfileByAnswer;
export const ENDPOINT_GET_QUIZ_PROFILES_BY_INTERVIEW = quizProfileByidInterview;
export const ENDPOINT_FINISH_QUIZ = finishQuiz;
export const ENDPOINT_SEND_EMAIL_QUIZ = sendEmail;
export const ENDPOINT_SEND_EMAIL_QUIZ_LOTE = sendEmailLote;

//-----------------------------------------------------------------------------//
//report
const reportControl = `${version}/report`;
const downloadResultReport = `${reportControl}/interview`;
const downloadClassReport = `${reportControl}/class`;
const validateGenerationReport = `public/report-online-validate-before-generation`;

export const ENDPOINT_VALIDATE_REPORT = validateGenerationReport;
export const ENDPOINT_DOWNLOAD_RESULT_REPORT = downloadResultReport;
export const ENDPOINT_DOWNLOAD_CLASS_REPORT = downloadClassReport;

//-----------------------------------------------------------------------------//
//result-profile
const notasErespostas = `${version}/result-profile/score/interview`;
const pendingInterview = `${version}/evaluation-result/evaluate`;
const evaluateByCceScore = `${version}/evaluation-result/evaluate-by-cce-score`;
export const ENDPOINT_VISUALIZAR_NOTAS_E_RESPOSTAS = notasErespostas;
export const ENDPOINT_PENDING_INTERVIEW = pendingInterview;
export const ENDPOINT_EVALUATE_BY_CCE_SCORE = evaluateByCceScore;

//-----------------------------------------------------------------------------//
//JOHARI
const getJohariData = `public/johari/step`;
const getJohariDataInterview = `public/johari/interview`;
const saveJohari = `public/johari/answer`;
export const ENDPOIfNT_PEGAR_DADOS_JOHARI = getJohariData;
export const ENDPOIfNT_PEGAR_DADOS_INTERVIEW_JOHARI = getJohariDataInterview;
export const ENDPOIfNT_SALVAR_JOHARI = saveJohari;

//avaliacao
const avaliarEntrevista = `${version}/evaluation-result/interview`;
export const ENDPOIfNT_AVALIAR_ENTREVISTA = avaliarEntrevista;

//-----------------------------------------------------------------------------//
//report
const generateDataReport = `public/report/interview`;
export const ENDPOINT_GENERATE_REPORT = generateDataReport;

//-----------------------------------------------------------------------------//
//public  class
const classroom = `public/class-room`;
const saveInterview = `public/interviews`;
export const ENDPOINT_GET_LIST_CLASS = classroom;
export const ENDPOINT_SAVE_INTERVIEW = saveInterview;

//-----------------------------------------------------------------------------//
//Param System
const paramSystem = `${version}/param-system`;
export const ENDPOINT_FIND_RESPONSER_METHOD = `${paramSystem}/interview`;
